<template>
  <Primitive
    v-bind="forwarded"
    :class="['input-group-text', props.class]"
  >
    <slot />
  </Primitive>
</template>

<script setup>
import { Primitive, useForwardProps } from 'radix-vue'
import { computed } from 'vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: null, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'span' },
})

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardProps(delegatedProps)
</script>
